<template>
  <div class="basket-item" v-if="item_title">
    <div class="basket-item__header">
      <span
        v-if="
          prop_parking_cartitem &&
          prop_parking_cartitem.product_display_name &&
          setbrandid != 'RDU' &&
          setbrandid != 'NWI' &&
          setbrandid != 'HER'
        "
        class="basket-item__title"
        >{{ getrans(prop_parking_cartitem.product_display_name) }}</span
      >
      <span v-else class="basket-item__title">{{ getrans(item_title) }}</span>
      <span class="basket-item__price">
        {{ currency_formatter(parseFloat(tot_price).toFixed(2)) }}
      </span>
    </div>

    <div class="basket-item__dates">
      <div class="basket-item__block">
        <span class="basket-item__start_date"
          ><i class="far fa-calendar"></i> {{ date_formatter(item_start_date_m) }}</span
        >
        <span class="basket-item__start_time"
          ><i class="far fa-clock"></i> {{ item_start_time_m }}</span
        >
      </div>

      <span class="basket-item__start_to">{{ getrans("to") }}</span>

      <div class="basket-item__block">
        <span class="basket-item__end_date"
          ><i class="far fa-calendar"></i> {{ date_formatter(item_end_date_m) }}</span
        >
        <span class="basket-item__end_time"
          ><i class="far fa-clock"></i> {{ item_end_time_m }}</span
        >
      </div>
    </div>
  </div>

  <div class="basket-item" v-if="prop_lounge_cartitem">
    <div class="basket-item__header">
      <span class="basket-item__title">{{
        getrans(prop_lounge_cartitem.product_name)
      }}</span>
      <span class="basket-item__price">
        {{currency_formatter(
          final_amount_paid_tot == "0"
            ? "0.00"
            : lngtotal == "0"
            ? parseFloat(prop_lounge_cartitem.loungesubtotal).toFixed(2)
            : lngtotal.toFixed(2)
        )}}</span
      >
    </div>
    <div class="basket-item__dates">
      <div class="basket-item__block basket-item__block--no-end-date">
        <span class="basket-item__start_date"
          ><i class="far fa-calendar"></i>
          {{ date_formatter(prop_lounge_cartitem.date_selected_display) }}</span
        >
        <span class="basket-item__start_time"
          ><i class="far fa-clock"></i>
          {{ prop_lounge_cartitem.time_selected }}</span
        >

        <span class="basket-item__total-people"
          ><i class="fas fa-user"></i>
          {{
            Number(prop_lounge_cartitem.ADL) +
            Number(prop_lounge_cartitem.CHD) +
            Number(prop_lounge_cartitem.INF)
          }}</span
        >
      </div>
    </div>
    <div class="basket-item__age-groups">
      <span
        class="basket-item__age-group"
        v-if="Number(prop_lounge_cartitem.ADL) > 0"
        >{{ getrans(text_adults) }}: {{ prop_lounge_cartitem.ADL }}</span
      >
      <span
        class="basket-item__age-group"
        v-if="Number(prop_lounge_cartitem.CHD) > 0"
        >{{ getrans(text_children) }}: {{ prop_lounge_cartitem.CHD }}</span
      >
      <span
        class="basket-item__age-group"
        v-if="Number(prop_lounge_cartitem.INF) > 0"
        >{{ getrans(text_infants) }}: {{ prop_lounge_cartitem.INF }}</span
      >
    </div>
  </div>

  <!-- {{adhoc_lounge_cart}} -->
  <template v-for="(cartitem_item, i) in adhoc_lounge_cart" :key="'ADHOC-' + i">
    <template v-if="cartitem_item !== null && cartitem_item.pr_type === 'S'"
      ><div class="basket-item">
        <div class="basket-item__header">
          <span class="basket-item__title">{{
            getrans(cartitem_item.pr_name)
          }}</span>

          <span class="basket-item__price">{{
            currency_formatter(cartitem_item.pr_price)
          }}</span>
        </div>
      </div>
    </template>
    <template v-else-if="cartitem_item !== null">
      <template
        v-for="(multi_item, j) in cartitem_item"
        :key="'ADHOC-cartitem_item-' + j"
        ><div class="basket-item">
          <div class="basket-item__header">
            <span class="basket-item__title">{{ multi_item.pr_name }}</span>

            <span class="basket-item__price">{{
              currency_formatter(multi_item.pr_price)
            }}</span>
          </div>
        </div>
      </template>
    </template>
  </template>

  <!-- FASTTRACK -->
  <div class="basket-item" v-if="prop_fasttrack_cartitem">
    <template
      v-for="(prop_fasttrack_cartitem_item, i) in prop_fasttrack_cartitem"
      :key="'FTT-' + i"
    >
      <div class="basket-item__header">
        <span class="basket-item__title">{{
          getrans(prop_fasttrack_cartitem_item.product_name)
        }}</span>
        <span
          class="basket-item__price">
          {{
            currency_formatter(
          final_amount_paid_tot == "0"
            ? "0.00"
            : ftttotal == "0"
            ? parseFloat(prop_fasttrack_cartitem_item.fasttracksubtotal).toFixed(2)
            : ftttotal.toFixed(2)
        )
          }}
        </span>
      </div>
      <div class="basket-item__dates">
        <div class="basket-item__block basket-item__block--no-end-date">
          <span class="basket-item__start_date"
            ><i class="far fa-calendar"></i>
            {{ date_formatter(prop_fasttrack_cartitem_item.date_selected_display) }}</span
          >
          <span class="basket-item__start_time"
            ><i class="far fa-clock"></i>
            {{ prop_fasttrack_cartitem_item.time_selected }}</span
          >

          <span class="basket-item__total-people"
            ><i class="fas fa-user"></i>
            {{
              Number(prop_fasttrack_cartitem_item.ADL) +
              Number(prop_fasttrack_cartitem_item.CHD) +
              Number(prop_fasttrack_cartitem_item.INF)
            }}</span
          >
        </div>
      </div>

      <div class="basket-item__age-groups">
        <span
          class="basket-item__age-group"
          v-if="Number(prop_fasttrack_cartitem_item.ADL) > 0"
          >{{ getrans("Adults") }}: {{ prop_fasttrack_cartitem_item.ADL }}</span
        >
        <span
          class="basket-item__age-group"
          v-if="Number(prop_fasttrack_cartitem_item.CHD) > 0"
          >{{ getrans("Children") }}:
          {{ prop_fasttrack_cartitem_item.CHD }}</span
        >
        <span
          class="basket-item__age-group"
          v-if="Number(prop_fasttrack_cartitem_item.INF) > 0"
          >{{ getrans("Infants") }}:
          {{ prop_fasttrack_cartitem_item.INF }}</span
        >
      </div>
    </template>
  </div>

  <!-- {{adhoc_cart}} -->
  <template v-for="(cartitem_item, i) in adhoc_cart" :key="'ADHOC-' + i">
    <template v-if="cartitem_item !== null && cartitem_item.pr_type === 'S'"
      ><div class="basket-item">
        <div class="basket-item__header">
          <span class="basket-item__title">{{
            getrans(cartitem_item.pr_name)
          }}</span>

          <span class="basket-item__price">{{
            currency_formatter(typeof cartitem_item.discounted_price === 'number' ? parseFloat(cartitem_item.discounted_price).toFixed(2) : cartitem_item.pr_price)
          }}</span>
        </div>
      </div>
    </template>
    <template v-else-if="cartitem_item !== null">
      <template
        v-for="(multi_item, j) in cartitem_item"
        :key="'ADHOC-cartitem_item-' + j"
        ><div class="basket-item">
          <div class="basket-item__header">
            <span class="basket-item__title">{{ multi_item.pr_name }}</span>

            <span class="basket-item__price">{{
              currency_formatter(multi_item.pr_price)
            }}</span>
          </div>
        </div>
      </template>
    </template>
  </template>
</template>
<script>
import md5 from "js-md5";
const axios = require("axios");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
export default {
  name: "BasketItemConfirmation",
  props: {
    prop_parking_cartitem: undefined,
    prop_fasttrack_cartitem: undefined,
    prop_lounge_cartitem: undefined,
    tot_price: undefined,
    item_price: undefined,
    item_title: undefined,
    item_start_date: undefined,
    item_start_time: undefined,
    item_end_date: undefined,
    item_end_time: undefined,
    lang: undefined,
    translations: undefined,
    final_amount_paid_tot: undefined,
  },
  data() {
    return {
      text_adults: "Adults",
      text_children: "Children",
      text_infants: "Infants",
      setbrandid: "",
      currency: "",
      item_start_date_m: "",
      item_start_time_m: "",
      item_end_date_m: "",
      item_end_time_m: "",
      lngtotal: "0",
      cpktotal: "0",
      ftttotal: "0",
      adhoc_cart: [],
      adhoc_lounge_cart: [],
    };
  },
  computed: {
    usFormatBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_US_FORMAT);
      } catch (e) {
        console.error("Failed to parse VUE_APP_US_FORMAT:", e);
        return [];
      }
    }
  },
  methods: {
    date_formatter(string) {
      if (process.env.VUE_APP_DATE_SEPARATOR_DOT && JSON.parse(process.env.VUE_APP_DATE_SEPARATOR_DOT).includes(this.setbrandid)) {
        return string.replaceAll('/', '.');
      }
      return string;
    },
    currency_formatter(money) {
      if (!money) return;
      const arrayString = process.env.VUE_APP_CURRENCY_AFTER_VALUE;
      const array = JSON.parse(arrayString);
      if (array.includes(this.setbrandid)) {
        money = money.toString().replace('.',',');
        return money + " " + this.currency;
      }
      return this.currency + " " + money;
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      console.log(ss); 
      return this.translations[ss] || string;
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/gtbrnslg.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response.data.slug);
          console.log(response.data.currency);
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.currency = response.data.currency;

            if (response.data.slug == "HER") {
              this.text_adults = "Standard (Ages 6+)";
              this.text_children = "Child (0-5)";
            }

            if (response.data.slug == "FMM") {
              this.text_adults = "People";
            }

            if (
              process.env.VUE_APP_CURRENCY_EURO && JSON.parse(process.env.VUE_APP_CURRENCY_EURO).includes(response.data.slug)
            ) {
              this.currency = "€";
            }
            if (
              this.usFormatBrands.indexOf(this.setbrandid) > -1
            ) {
              var farray = this.item_start_date.split("/");
              console.log("item_start_date", this.item_start_date);
              this.item_start_date_m =
                farray[1] + "/" + farray[0] + "/" + farray[2];
              console.log("item_start_date_m", this.item_start_date_m);
              this.item_start_time_m = this.formatTime(this.item_start_time);
              var earray = this.item_end_date.split("/");
              this.item_end_date_m =
                earray[1] + "/" + earray[0] + "/" + earray[2];
              this.item_end_time_m = this.formatTime(this.item_end_time);
            } else {
              this.item_start_date_m = this.item_start_date;
              this.item_start_time_m = this.item_start_time;
              this.item_end_date_m = this.item_end_date;
              this.item_end_time_m = this.item_end_time;
            }

            //this.loadTranslations();
            //this.getBrandData();
          }
        });
    },
    formatTime(timeString) {
      let [hourString, minute] = timeString.split(":");
      let hour = +hourString % 24;
      return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
    },
  },
  mounted() {
    //this.setbrandid = "BOS";this.currency="$";
    if (
      encryptStorage.getItem("finaltotalvalue_lng") !== undefined &&
      encryptStorage.getItem("finaltotalvalue_lng") !== null
    ) {
      this.lngtotal = encryptStorage.getItem("finaltotalvalue_lng");
    }

    if (
      encryptStorage.getItem("finaltotalvalue_cpk") !== undefined &&
      encryptStorage.getItem("finaltotalvalue_cpk") !== null
    ) {
      this.cpktotal = encryptStorage.getItem("finaltotalvalue_cpk");
    }

    if (
      encryptStorage.getItem("finaltotalvalue_ftt") !== undefined &&
      encryptStorage.getItem("finaltotalvalue_ftt") !== null
    ) {
      let fttfinalamount = 0;
      this.prop_fasttrack_cartitem.forEach(function (fasttrack_cartitem_arrayItem) {
      let finaltotalvalue_ftt = encryptStorage.getItem("finaltotalvalue_ftt");
      if (finaltotalvalue_ftt["ftt" + fasttrack_cartitem_arrayItem.product_id]) {
      fttfinalamount = parseFloat(finaltotalvalue_ftt["ftt" + fasttrack_cartitem_arrayItem.product_id].finalamount);
      }
      });
      
      this.ftttotal = parseFloat(fttfinalamount).toFixed(2);
    }
    this.getbranded();
    if (!this.item_start_date) {
      return;
    }
    var farray = this.item_start_date.split("/");
    this.item_start_date_m = farray[1] + "/" + farray[0] + "/" + farray[2];
    this.item_start_time_m = this.formatTime(this.item_start_time);
    var earray = this.item_end_date.split("/");
    this.item_end_date_m = earray[1] + "/" + earray[0] + "/" + earray[2];
    this.item_end_time_m = this.formatTime(this.item_end_time);

    //   console.log("window.location.hostname", window.location.hostname);
    // if(this.setbrandid=="")
    // {
    //   this.setbrandid = "BOS";this.currency="$";
    //   if (window.location.hostname == "herv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "HER";this.currency="€";
    //   }
    //   if (window.location.hostname == "nwiv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "NWI";this.currency="£";
    //   }
    //   if (window.location.hostname == "rduv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "RDU";this.currency="$";
    //   }
    //   if (window.location.hostname == "bosv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "BOS";this.currency="$";
    //   }
    // }
    this.adhoc_cart = encryptStorage.getItem("adhoc_cart");
    window.addEventListener(
      "update_basket",
      () => {
        this.adhoc_cart = encryptStorage.getItem("adhoc_cart");
      },
      false
    );

    this.adhoc_lounge_cart = encryptStorage.getItem("adhoc_lounge_cart");
    sessionStorage.setItem("adhoc_lounge_cart_temp", null);
    this.last_lounge_search = encryptStorage.getItem("last_lounge_search");
    window.addEventListener(
      "update_basket",
      () => {
        this.adhoc_lounge_cart = encryptStorage.getItem("adhoc_lounge_cart");
        sessionStorage.setItem("adhoc_lounge_cart_temp", null);
        this.last_lounge_search = encryptStorage.getItem("last_lounge_search");
      },
      false
    );
  },
};
</script>

<style lang="scss">
.basket-item + .basket-item {
  border-top: 1px solid #ddd;
  .basket-item__header {
    margin: 0.825rem 0 0rem;
  }
}

.basket-item {
  padding: 0.825rem 0;

  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__title {
    // font-weight: bold;
    // color: #1a2a40;
    // font-size: 1.125rem;
    font-family: var(--details_headings_font_family, inherit);
    font-size: var(--details_headings_font_size, 1.125rem);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #1a2a40);
  }

  &__dates {
    display: flex;
    justify-content: flex-start;
    font-size: 0.925rem;
    color: #707070;
    font-weight: bold;
    margin: 0.5rem 0 0;
    gap: 1rem;
  }

  &__age-groups {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    font-size: 0.925rem;
    color: #707070;
    font-weight: bold;
    margin: 0.5rem 0 0;
    gap: 1rem;
  }

  &__age-group {
  }

  &__price {
    font-weight: bold;
    font-size: 1.125rem;
    font-family: var(--basket_price_font_family, inherit);
    font-weight: var(--basket_price_font_weight, bold);
    color: var(--basket_price_font_color, #236ca3);
  }

  &__block {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    flex-wrap: wrap;
    span {
      display: inline-block;
    }
  }

  &__block--no-end-date {
    max-width: 100%;
    justify-content: flex-start;
    gap: 1rem;
  }

  &__start_to {
    padding: 0 1rem;
  }
}
</style>
